import Swiper, { SwiperSlide } from "./Swiper";
import Preloader from "./Preloader";
import ErrorMessage from "./ErrorMessage";
import useFetch from "../hooks/use-fetch";

const params = {
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: true,
};

const HeroSlider = () => {
  type dataType = {
    id: number;
    title: string;
    subtitle: string;
    image: string;
  };

  const { data, isLoading, errorMessage } = useFetch<dataType[]>("banner.json");

  if (isLoading) return <Preloader />;
  if (errorMessage) return <ErrorMessage errorMessage={errorMessage} />;
  return (
    <div className="hero-slider space-y--20">
      <div className="container">
        <div className="row row-10">
          <div className="col-12">
            <div className="hero-slider-wrapper">
              {data && data.length && (
                <Swiper options={params}>
                  {data.map((single: any) => (
                    <SwiperSlide key={single.id}>
                      <div className="hero-slider-item d-flex">
                        <img
                          className="img-fluid"
                          src={process.env.PUBLIC_URL + single.image}
                          alt=""
                        />
                        <div className="container">
                          <div className="row">
                            <div className="col-12">
                              {/* hero slider content */}
                              <div className="hero-slider-content">
                                <h2
                                  className="hero-slider-content__title space-mb--10"
                                  dangerouslySetInnerHTML={{
                                    __html: single.title,
                                  }}
                                ></h2>
                                <p className="hero-slider-content__text">
                                  {single.subtitle}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
